import { useCallback } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import Animated from 'react-native-reanimated';

import { useNavigation } from '@react-navigation/native';

import { Box } from '@/components/lib/components';
import { GASbkEvents } from '@/feature/analytics/sbk/ga-sbk-events';
import { useSelectionCount } from '@/feature/betslip-sbk/hooks/betslip-hooks';
import { useBetSlipInitialTab } from '@/feature/betslip-sbk/hooks/betslip-hooks';
import { PICK_BAR_BOTTOM_DISTANCE } from '@/feature/lobby/components/FantasyPickbar';
import { styles as pickbarStyles } from '@/feature/lobby/components/FantasyPickbar';
import { getLayoutAnimationsTransition } from '@/utils/animations/layout-animations-utils';

import { PickSlipBarContent } from './PickSlipBarContent/PickSlipBarContent';

export const PICK_SLIP_BAR_HEIGHT = 72;

export const PickSlipBar = () => {
    const selectionCount = useSelectionCount();
    const initialTab = useBetSlipInitialTab();
    const navigation = useNavigation();

    const handlePress = useCallback(() => {
        GASbkEvents.clickViewBets(selectionCount);
        navigation.navigate('BetSlipStack', { screen: 'BetSlipModal', params: { screen: initialTab } });
    }, [selectionCount, initialTab, navigation]);

    const layoutTransition = getLayoutAnimationsTransition();

    return (
        <Box>
            <Animated.View
                layout={layoutTransition}
                style={[styles.container, pickbarStyles.container, pickbarStyles.shadow]}
            >
                <TouchableOpacity onPress={handlePress} style={styles.button}>
                    <PickSlipBarContent />
                </TouchableOpacity>
            </Animated.View>
        </Box>
    );
};

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        bottom: PICK_BAR_BOTTOM_DISTANCE,
    },
    button: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderCurve: 'continuous',
        borderRadius: 28,
        overflow: 'hidden',
        zIndex: 10,
        gap: 12,
        paddingLeft: 20,
        paddingRight: 12,
    },
});
